import { apiAuth } from "../../http";

export const deleteProfile = async (id: string): Promise<[]> => {
  const response = apiAuth()
    .delete(`/profiles/${id}`)
    .then(({ data }) => data);
  return response;
};
